import type { ComponentProps } from 'react';
import { OperatorSelectList } from './OperatorSelect.constants';
import HubertCombobox from 'components/HubertUI/HubertCombobox';

interface Props extends ComponentProps<'div'> {
  isMulti?: boolean;
  value?: string | string[];
  onValueChange?: (value: string | string[]) => void;
  disabled?: boolean;
  include?: string[];
}

const OperatorCombobox = ({
  isMulti = false,
  onValueChange,
  value,
  disabled = false,
  include = [],
  ...props
}: Props) => {
  const items = include.length
    ? OperatorSelectList.filter((option) => include.includes(option.value))
    : OperatorSelectList;

  return (
    <div {...props}>
      <HubertCombobox
        itemName="operator"
        isMulti={isMulti}
        items={items}
        onValueChange={onValueChange}
        value={value}
        disabled={disabled}
      />
    </div>
  );
};

export default OperatorCombobox;
